import type { ILegendItem } from 'components/Charts/Legend/Legend';
import { Legend } from 'components/Charts/Legend/Legend';

import type React from 'react';

import Style from './TitleWithLegend.module.css';

interface ITitleWithLegend {
    title: string;
}

const legendItems: ILegendItem[] = [
    {
        title: 'Принято в Акте КС-2',
        color: 'rgb(86, 185, 242)',
    },
    {
        title: 'Согласовано СКзC',
        color: 'rgb(34, 195, 142)',
    },
];

export const TitleWithLegend: React.FC<ITitleWithLegend> = (props) => {
    const { title } = props;

    return (
        <div className={Style.titleWithLegend}>
            <div className={Style.titleWithLegendTitle}>{title}</div>
            <Legend className={Style.titleWithLegendLegend} items={legendItems} />
        </div>
    );
};

TitleWithLegend.displayName = 'TitleWithLegend';
